import { FrameValue, Interpolation } from '@react-spring/web';

export const getNormalizedOffsetInterpolator = (
  value: FrameValue<number>,
  range: readonly number[],
): Interpolation<number, number> =>
  value.to({
    range: [0, 1],
    output: [0, range[1] - range[0]],
  });
